import { effects } from 'redux-saga'

import {
  receiveSuggestionsError,
} from '../../modules/autocomplete'

export default function makeAddressAutocomplete({
  raven,
  search,
}) {
  return function* addressAutocomplete(action) {
    try {
      return yield effects.call(
        search,
        action.payload.query,
      )
    } catch (e) {
      // The error objects browsers are returning are shit, the best we can do is look for TypeError
      // or TypeMismatchError (Edge).
      if ((e.response && e.response.status < 500) || /TypeError/.test(e) || /TypeMismatchError/.test(e)) {
        if (raven) {
          raven.captureMessage('Failed to request autocomplete data', { extra: { e } })
        }

        // We've had a failure connecting to ES, but it isnt fatal..
        yield effects.put.resolve(receiveSuggestionsError(action.payload.type, action.payload.query))

        return []
      }

      throw e
    }
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/autocomplete/address.js